// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "stepTitle-2LvlS";
var _4 = "buttons-2_EIK";
var _5 = "prices-1luCe";
var _6 = "wide-3lEsU";
var _7 = "backButton-1cAj_";
var _8 = "nasServicesNotice-29RVY";
var _9 = "warningModalContent-3rVDI";
var _a = "scrollBody-3vZiM";
var _b = "paper-12jQJ";
var _c = "wrapper-1VMyZ";
var _d = "mobileStep-1k7qy";
var _e = "passed-2zRbQ";
var _f = "withoutTopBorderRadius-1V_go";
var _10 = "withoutBottomBorderRadius-2U7Q-";
var _11 = "withTopBorder-20lYL";
var _12 = "reasonDescr-3_TTJ";
export { _1 as "__esModule", _2 as "mobile", _3 as "stepTitle", _4 as "buttons", _5 as "prices", _6 as "wide", _7 as "backButton", _8 as "nasServicesNotice", _9 as "warningModalContent", _a as "scrollBody", _b as "paper", _c as "wrapper", _d as "mobileStep", _e as "passed", _f as "withoutTopBorderRadius", _10 as "withoutBottomBorderRadius", _11 as "withTopBorder", _12 as "reasonDescr" }
export default { "__esModule": _1, "mobile": _2, "stepTitle": _3, "buttons": _4, "prices": _5, "wide": _6, "backButton": _7, "nasServicesNotice": _8, "warningModalContent": _9, "scrollBody": _a, "paper": _b, "wrapper": _c, "mobileStep": _d, "passed": _e, "withoutTopBorderRadius": _f, "withoutBottomBorderRadius": _10, "withTopBorder": _11, "reasonDescr": _12 }
